var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import PersonService from "./Person.service";
import FetchService from "./Shared/FetchService";
import WorkflowNodeDomainService from "../Domain/WorkflowNode/WorkflowNode.service";
// @ts-expect-error - TS7006 - Parameter 'ms' implicitly has an 'any' type.
const wait = (ms) => new Promise((res) => setTimeout(res, ms));
const BASE_URL = "/aviso/workflow";
export default class WorkflowService {
    static getWorkflowNodeDefinition(nodeDefinitionId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield wait(2000);
            const [olivia] = yield PersonService.simpleSearch("Olivia Student", 1);
            // just a stub for now, change nodeType to see different forms
            // CreateEmail to see Send Message Action Form
            // ChangeStage to see Change Stage Action Form
            // EnrollOpportunityInCampaign to see Enroll in Campaign Action Form
            return {
                nodeType: "PersonLoader",
                criteria: {
                    person: olivia,
                },
            };
        });
    }
    static resetCancelledOrFailedNode(workflowNodeId) {
        return FetchService.postSingleResponse(BASE_URL + "/resetCancelledOrFailedNode", { workflowNodeId }).then(WorkflowNodeDomainService.fromJSON);
    }
}
